module.exports = __webpack_public_path__ + "static/media/05_sustainability.0111a994.png";